import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TopStudyLocationsComponent} from './top-study-locations.component';

const routes: Routes = [
    {
        path: 'top-study-locations',
        component: TopStudyLocationsComponent,
        data: {animation: 'top-study-locations'}
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class TopStudyLocationsRoutingModule {
}
